// extracted by mini-css-extract-plugin
export default {"mainArea":"KGB98pb7dAwZzAHmPpx_"};